var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChevronLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9431 7.05752C21.4638 7.57822 21.4638 8.42244 20.9431 8.94313L13.8859 16.0003L20.9431 23.0575C21.4638 23.5782 21.4638 24.4224 20.9431 24.9431C20.4224 25.4638 19.5782 25.4638 19.0575 24.9431L11.0575 16.9431C10.5368 16.4224 10.5368 15.5782 11.0575 15.0575L19.0575 7.05752C19.5782 6.53682 20.4224 6.53682 20.9431 7.05752Z",
    fill: "#60666E"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChevronLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chevron-left.e1ef68535eb554d62ca117846da07ed2.svg";